module.exports = __webpack_public_path__ + "img/mp4.96dfce20.jpg";